const fetch = require("node-fetch");

export class HttpError extends Error {
  status: number;
  errorBody?: any;

  constructor(status: number, errorBody?: any) {
    super(`Request failed with status ${status}`);
    this.name = "HttpError";
    this.status = status;
    this.errorBody = errorBody;
  }
}

const apiURLForPath = (apiBaseURL: string, path: string): string => {
  if (path.charAt(0) !== "/") {
    return `${apiBaseURL}/${path}`;
  }
  return apiBaseURL + path;
};

const hasFileHelper = (body?: any): boolean => {
  let hasFile = false;
  for (const key in body) {
    if (body[key] instanceof Blob) {
      hasFile = true;
    }
  }
  return hasFile;
};

// File Picker will use these helpers because we cant use the fetchWithoutAuth helper do to needing our fetching from multiple endpoints to happen
// synchronously and waiting for all fetches to finish before we process the responses (for drives, folders, and files)
const formatUpdatedHeaders = (
  headers?: {
    [key: string]: string;
  },
  body?: any
): { [key: string]: string } | Headers => {
  let updatedHeaders: { [key: string]: string } | Headers = headers || {};
  const hasFile = hasFileHelper(body);
  if (hasFile) {
    updatedHeaders = new Headers();
    for (const key in headers) {
      updatedHeaders.append(key, headers[key]);
    }
  } else {
    updatedHeaders["Content-Type"] = "application/json;charset=UTF-8";
  }

  return updatedHeaders;
};

const formatUpdatedBody = (method: string, body?: any) => {
  let updatedBody: any = body && method !== "GET" ? JSON.stringify(body) : null;
  const hasFile = hasFileHelper(body);
  if (hasFile) {
    updatedBody = null;
    if (body) {
      updatedBody = new FormData();
      for (const key in body) {
        updatedBody.append(key, body[key]);
      }
    }
  }
  return updatedBody;
};

export const fetchWithoutAuth = ({
  apiBaseURL,
  path,
  method = "GET",
  headers = {},
  body,
  queryParams,
  onResponse,
  onError,
}: {
  apiBaseURL: string;
  path: string;
  method: string;
  headers?: { [key: string]: string };
  body?: any;
  queryParams?: { [key: string]: any };
  onResponse: (response: any) => void;
  onError?: (error: Error, errorBody?: any) => void;
}) => {
  const url = apiURLForPath(apiBaseURL, path);
  const params = queryParams ? "?" + new URLSearchParams(queryParams) : "";
  const updatedHeaders = formatUpdatedHeaders(headers, body);
  const updatedBody = formatUpdatedBody(method, body);

  fetch(url + params, {
    method,
    headers: updatedHeaders,
    body: updatedBody,
  })
    .then((response: any) => {
      if (response.ok) {
        return response.json();
      }
      const status = response.status;
      return response.json().then(
        (errorBody: any) => {
          throw new HttpError(status, errorBody);
        },
        () => {
          throw new HttpError(status);
        },
      );
    })
    .then((data: any) => {
      onResponse(data);
    })
    .catch((e: any) => {
      if (onError) {
        const errorBody = e instanceof HttpError ? e.errorBody : undefined;
        onError(e instanceof Error ? e : new Error("Request failed"), errorBody);
      }
    });
};
